/* Собрано из layouts/app.blade.php скриптом storage/app/extract-layout-js.php.
   Четыре блока, одинаковые на всех локалях и обоих доменах, вынесены сюда,
   чтобы браузер и поисковый робот скачивали их один раз, а не на каждой
   странице (замер 16.09.2026: 26 КБ сырых на странице, ~7 КБ по проводу).
   Порядок сохранён. Каждый блок сам проверяет, есть ли его DOM. */

/* ── size-hint ─────────────────────────────────────────────── */
(function(){
        /* ⚠️ Все локали из config('app.supported_locales'). Пока блок жил inline
           в блейде, de/es/fr/uk в карте не было вовсе, и подсказка у зоны
           загрузки показывала им английское «Max» — сторож
           InlineLocaleLabelCompletenessTest сканирует public/js/**, а блейды
           нет, поэтому пропуск нашёлся только при выносе файла наружу. */
        var L = {
            en:{max:'Max'},ru:{max:'Макс.'},ko:{max:'최대'},
            ar:{max:'الحد الأقصى'},id:{max:'Maks.'},pt:{max:'Máx.'},
            de:{max:'Max.'},es:{max:'Máx.'},fr:{max:'Max.'},uk:{max:'Макс.'}
        };
        /* Вид зоны — только по MIME-маске в accept. Зона «любой файл» (маска
           «звёздочка/звёздочка»), документов или архивов вида НЕ имеет: до
           26.09.2026 здесь стоял
           откат на 'audio', и /checksum-calculator — хеш любого файла —
           печатал в зоне «MP3, WAV, FLAC, OGG, M4A, AAC, OPUS · Макс. 1024 МБ».
           Без вида честная вывеска — только явные расширения из accept. */
        function detectKind(accept){
            if (/video\//i.test(accept)) return 'video';
            if (/audio\//i.test(accept)) return 'audio';
            if (/image\//i.test(accept)) return 'image';
            return null;
        }
        var FALLBACK_EXTS = {
            audio: ['MP3','WAV','FLAC','OGG','M4A','AAC','OPUS'],
            video: ['MP4','WebM','MOV','AVI','MKV'],
            image: ['JPG','PNG','WebP','GIF']
        };
        function extractExts(accept, kind){
            var seen = {};
            var out = [];
            accept.split(',').forEach(function(s){
                s = s.trim();
                if (s.charAt(0) === '.') {
                    var e = s.slice(1).toUpperCase();
                    if (!seen[e]) { seen[e] = 1; out.push(e); }
                }
            });
            /* No explicit .ext entries (e.g. accept="video/*") — fall back to popular formats for the kind */
            if (!out.length && FALLBACK_EXTS[kind]) return FALLBACK_EXTS[kind].slice();
            return out;
        }
        function setup(){
            /* The hint belongs INSIDE the drop zone, next to the headline that */
            /* asks for the file. It used to be appended to .workspace-placeholder */
            /* — a separate "Upload a file to start" line под зоной, which made */
            /* three consecutive upload prompts (zone title → "drag here" → */
            /* placeholder) and printed the size twice in two different units */
            /* ("Макс. 1 ГБ" in the zone, "Макс. 1024 МБ" below it). The */
            /* placeholder is gone (2026-08-13); the hint moved here. */
            var zone = document.querySelector('.tool-uploader');
            if (!zone) return;
            /* Zones rendered in auto mode already ship .tu-formats — that IS the */
            /* canonical line, injecting a second one duplicated the list on */
            /* 3d-audio / audio-degrader / voice-enhancer. Only slot-mode zones */
            /* (custom markup inside the escape hatch) reach the code below. */
            if (zone.querySelector('.tu-formats')) return;
            /* Find ANY file input with accept on the page (not just inside .upload-zone) */
            /* so tools using custom upload classes (.ev-upload, .cb-upload, etc.) also get the hint. */
            var input = document.querySelector('input[type=file][accept]');
            if (!input) return;
            /* Читаем accept ЗОНЫ, а не инпута: tool-uploader.js дописывает в */
            /* инпут .mts/.m2ts/.ts (и на iOS — целые наборы), чтобы системный */
            /* выбор файлов не прятал их за «All files». Это про ПИКЕР, а не про */
            /* то, что тул умеет. С accept инпута вывеска у зоны с голым */
            /* «video/*» состояла ровно из дописанного: «MTS, M2TS, TS» */
            /* (замерено 04.09.2026 на /enhance-video и /repair-video). */
            var accept = (zone.dataset && zone.dataset.accept)
                      || input.getAttribute('accept') || '';
            var kind = detectKind(accept);
            var exts = extractExts(accept, kind);
            if (!exts.length) return;
            /* Числовой max-mb у ЗОНЫ — это тот потолок, который загрузчик и */
            /* применяет (tool-uploader.js: parseInt(dataset.maxMb)). Вывеска */
            /* брала общий лимит вида и печатала «Макс. 1024 МБ» над зоной, */
            /* которая отказывает на 50 МБ (/school-bell, мелодии, 13.09.2026). */
            var zoneMb = (zone.dataset && /^[0-9]+$/.test(zone.dataset.maxMb || '')) ? parseInt(zone.dataset.maxMb, 10) : 0;
            /* Потолок — по виду, по которому зону меряет сам загрузчик
               (data-kind), а не по угаданному из accept. */
            var sizeKind = (zone.dataset && zone.dataset.kind) || kind;
            var limit = zoneMb > 0 ? zoneMb * 1048576
                     : ((window.__effectiveFileLimit && window.__effectiveFileLimit(sizeKind))
                     || (window.__FILE_LIMITS && window.__FILE_LIMITS[sizeKind])
                     || 0);
            if (!limit) return;
            var limitMB = Math.round(limit / 1048576);
            var locale = (window.__LOCALE || 'en').substring(0,2);
            var maxLabel = (L[locale] || L.en).max;
            /* Единица тоже локальная, и раньше знала только ru и ar: украинский
               получал «MB» вместо «МБ», французский — «MB», хотя отказ ТОГО ЖЕ
               аплоадера по-французски говорит «Mo» (REJECT_L в tool-uploader.js).
               Подсказка и отказ обязаны называть одно и то же одинаково. */
            var UNIT = {
                en:'MB', ru:'МБ', ko:'MB', ar:'م.ب', id:'MB',
                pt:'MB', de:'MB', es:'MB', fr:'Mo', uk:'МБ'
            };
            var unitMB = UNIT[locale] || UNIT.en;
            /* Don't print the ceiling twice. Many slot zones already carry their */
            /* own max-size line (denoise's .upload-zone-hint "Макс. 1 ГБ"), and */
            /* appending "· Макс. 1024 МБ" right under it states the SAME number */
            /* in a different unit — which reads as two different limits. */
            /* Same size regex adaptHintSizes() below uses. */
            var hasSize = /(\d+(?:[.,]\d+)?)\s*(МБ|ГБ|MB|GB)/i.test(zone.textContent || '');
            var info = document.createElement('div');
            /* .tu-formats, not a bespoke class: it inherits the canonical style */
            /* AND makes the guard above idempotent on a second run. */
            info.className = 'tu-formats';
            info.textContent = hasSize ? exts.join(', ')
                                       : exts.join(', ') + ' · ' + maxLabel + ' ' + limitMB + ' ' + unitMB;
            (zone.querySelector('.tu-content') || zone).appendChild(info);
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
        else setup();

        /* ── Downgrade hardcoded "Max 1 GB" / "до 500 МБ" hints on low-RAM devices ── */
        /* 30+ tools hardcode their own max-size strings in translations. Instead of */
        /* editing 7 locales × 31 files, this scan finds upload-hint elements with a */
        /* size pattern and rewrites the number to the adaptive limit — but only if */
        /* that's strictly LOWER than the translator-chosen value (so tool-specific */
        /* tighter limits like "50 MB" in reverse are preserved). */
        function adaptHintSizes() {
            if (!window.__effectiveFileLimit) return;
            /* Match any tool-specific upload-hint class. `[class*=]` is */
            /* a whole-string substring match, so "upload-zone-hint" is NOT */
            /* caught by `[class*="upload-hint"]` (dash breaks it). We scope */
            /* separately: (a) common tool-specific classes; (b) any direct */
            /* descendant of an upload-ish container containing a size pattern. */
            var sel = '[class*="upload-formats"],[class*="upload-hint"],[class*="upload-limit"],' +
                      '[class*="upload-max"],[class*="upload-size"],[class*="upload-zone-formats"],' +
                      '[class*="upload-zone-hint"],[class*="upload-zone-limit"],[class*="upload-zone-max"],' +
                      '[class*="max-size"],[class*="formats-"],' +
                      '.formats,.upload-formats,.upload-hint,.upload-limit,' +
                      '.upload-zone-hint,.upload-zone-formats,.upload-zone-limit,.upload-zone-max,.upload-zone-size';
            var elsSet = new Set(document.querySelectorAll(sel));
            /* Also scan leaf text children inside explicit upload containers — */
            /* catches tools where the size lives on a generic div with no */
            /* upload-hint-ish class (e.g. inline styled divs under .xx-upload). */
            document.querySelectorAll('.upload-zone, [class*="-upload"], [class*="upload-"]').forEach(function(zone){
                zone.querySelectorAll('div, span, p').forEach(function(leaf){ elsSet.add(leaf); });
            });
            var els = Array.from(elsSet);
            var sizeRx = /(\d+(?:[.,]\d+)?)\s*(МБ|ГБ|MB|GB)/i;
            els.forEach(function(el) {
                /* Only rewrite leaf-ish elements — if el has element children, */
                /* replacing textContent would destroy nested structure. */
                if (el.children && el.children.length > 0) return;
                /* The shared uploader's own line has one owner — renderSizeHints */
                /* (tool-uploader.js) already prints the device number, the hard */
                /* max-mb, or the tool's __TOOL_MAX_MB. This pass is for hint texts */
                /* written by hand. Reaching into it lowered /video-compressor's */
                /* «до 4 ГБ» (max-mb="0": the tool owns the number) to the 'video' */
                /* kind's «до 1 ГБ» on every page load — measured 01.10.2026. */
                if (el.classList && el.classList.contains('tu-size-hint')) return;
                /* Жёсткий числовой max-mb на зоне — авторитет: его обеспечивает */
                /* сам гейт аплоадера, и «понижать» такую подпись до бюджета */
                /* памяти значит врать в обратную сторону. Ровно тот же принцип */
                /* уже записан в renderSizeHints («hard max-mb wins over the */
                /* device-memory budget»); без этой ветки честное «до 4 ГБ» у */
                /* мастеринга (потоковый лейн, RAM не нужен) переписывалось в */
                /* «до 1 ГБ» — замечено 06.08 при расследовании scriptdoc. */
                var tuZone = el.closest('.tool-uploader');
                if (tuZone && tuZone.dataset.maxMb && tuZone.dataset.maxMb !== 'auto'
                    && parseInt(tuZone.dataset.maxMb, 10) > 0) return;
                var txt = el.textContent || '';
                var m = txt.match(sizeRx);
                if (!m) return;
                var num = parseFloat(m[1].replace(',', '.'));
                var unitUp = m[2].toUpperCase();
                var isGig = unitUp === 'ГБ' || unitUp === 'GB';
                var origBytes = num * (isGig ? 1073741824 : 1048576);
                /* Kind: prefer an explicit data-kind on the element (or nearest */
                /* ancestor). The shared uploader's .tu-size-hint carries the */
                /* authoritative size-kind — e.g. "gif" is a 300 MB image-family */
                /* cap. Sniffing the accept string alone misclassifies these */
                /* size-only kinds (image/gif → 'image' → 100 MB) and would */
                /* "downgrade" the correct 300 MB hint renderSizeHints just wrote. */
                var zone = el.closest('[class*="upload"]') || document;
                var fi = zone.querySelector('input[type=file][accept]')
                      || document.querySelector('input[type=file][accept]');
                var accept = fi ? (fi.getAttribute('accept') || '') : '';
                var dkEl = el.closest('[data-kind]');
                var kind = (dkEl && dkEl.dataset.kind) ? dkEl.dataset.kind
                         : (/video\//i.test(accept) ? 'video'
                         : /image\//i.test(accept) ? 'image'
                         : /audio\//i.test(accept) ? 'audio'
                         : 'audio');
                var adaptive = window.__effectiveFileLimit(kind);
                if (adaptive >= origBytes) return;
                var newText;
                if (isGig && adaptive >= 1073741824) {
                    newText = (adaptive / 1073741824).toFixed(adaptive % 1073741824 === 0 ? 0 : 1) + ' ' + m[2];
                } else {
                    var mbUnit = (m[2] === 'ГБ') ? 'МБ' : (m[2] === 'GB' ? 'MB' : m[2]);
                    newText = Math.round(adaptive / 1048576) + ' ' + mbUnit;
                }
                el.textContent = txt.replace(m[0], newText);
            });
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adaptHintSizes);
        else adaptHintSizes();
    })();

/* ── timezone-push ─────────────────────────────────────────────── */
/* Stick the viewer's IANA timezone into a year-long cookie on first */
    /* page load. CaptureUserTimezone middleware reads it once per user */
    /* and saves to users.timezone so notifications can localise. */
    (function(){
        try {
            if (document.cookie.indexOf('vc_tz=') !== -1) return;
            var tz = (window.Intl && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : '';
            if (tz) document.cookie = 'vc_tz=' + encodeURIComponent(tz) + ';path=/;max-age=31536000;SameSite=Lax';
        } catch (e) {}
    })();
    /* Web Push subscription helper (M11 Phase 14). Exposes */
    /* window.__timbricaPush = {supported, state, subscribe, unsubscribe} so */
    /* any view can render its own opt-in UI without re-implementing the */
    /* Push API dance. Graceful no-op on unsupported browsers and when no */
    /* VAPID public key is published. */
    window.__timbricaPush = (function(){
        var supported = ('serviceWorker' in navigator) && ('PushManager' in window) && ('Notification' in window);
        function urlBase64ToUint8Array(b64) {
            var pad = '='.repeat((4 - b64.length % 4) % 4);
            var s = (b64 + pad).replace(/-/g, '+').replace(/_/g, '/');
            var raw = atob(s), arr = new Uint8Array(raw.length);
            for (var i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
            return arr;
        }
        async function state() {
            if (!supported) return 'unsupported';
            if (Notification.permission === 'denied') return 'blocked';
            try {
                var reg = await navigator.serviceWorker.ready;
                var sub = await reg.pushManager.getSubscription();
                return sub ? 'subscribed' : 'idle';
            } catch (e) { return 'idle'; }
        }
        /* Всё, кроме СОХРАНЕНИЯ подписки: разрешение, готовый воркер, ключ */
        /* VAPID, сама подписка. Вынесено, потому что владелец подписки не */
        /* всегда пользователь: у /elder-care наблюдающий намеренно без */
        /* аккаунта, и его подписка принадлежит комнате. Копировать сюда */
        /* второй urlBase64/requestPermission значило бы завести две ветки, */
        /* которые разъедутся молча. */
        async function subscribeRaw() {
            if (!supported) throw new Error('unsupported');
            var perm = await Notification.requestPermission();
            if (perm !== 'granted') throw new Error('denied');
            var reg = await navigator.serviceWorker.ready;
            var key = await fetch('/api/push/vapid-key').then(function(r){ return r.json(); });
            if (!key || !key.key) throw new Error('no_vapid_key');
            var sub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(key.key),
            });
            return sub.toJSON();
        }
        /* Отписаться в браузере и вернуть адрес, чтобы владелец убрал свою строку. */
        async function unsubscribeRaw() {
            if (!supported) return null;
            var reg = await navigator.serviceWorker.ready;
            var sub = await reg.pushManager.getSubscription();
            if (!sub) return null;
            var endpoint = sub.endpoint;
            await sub.unsubscribe();
            return endpoint;
        }
        async function subscribe() {
            var raw = await subscribeRaw();
            var sub = { toJSON: function(){ return raw; } };
            var csrf = document.querySelector('meta[name="csrf-token"]');
            var res = await fetch('/api/push/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf ? csrf.content : '' },
                body: JSON.stringify(sub.toJSON()),
            });
            if (!res.ok) throw new Error('persist_failed');
            return true;
        }
        async function unsubscribe() {
            if (!supported) return;
            var reg = await navigator.serviceWorker.ready;
            var sub = await reg.pushManager.getSubscription();
            if (!sub) return;
            var endpoint = sub.endpoint;
            await sub.unsubscribe();
            var csrf = document.querySelector('meta[name="csrf-token"]');
            await fetch('/api/push/unsubscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf ? csrf.content : '' },
                body: JSON.stringify({ endpoint: endpoint }),
            });
        }
        return { supported: supported, state: state, subscribe: subscribe, unsubscribe: unsubscribe,
                 subscribeRaw: subscribeRaw, unsubscribeRaw: unsubscribeRaw };
    })();

/* ── ffmpeg-loading ─────────────────────────────────────────────── */
(function(){
        var el=document.getElementById('ffmpeg-loading');
        var txt=document.getElementById('ffld-text');
        if(!el||!txt)return;
        var L=window.__LOCALE||'en';
        /* Detection-based "try a different browser" suggestion. Memory rule */
        /* feedback_advisory_must_use_detection.md: never offer "Open in Chrome" */
        /* to a Chrome user. We pick an alternative browser the user is NOT on. */
        var _ua=navigator.userAgent;
        var _isEdge=/Edg\//.test(_ua);
        var _isOpera=/OPR\//.test(_ua);
        var _isYandex=/YaBrowser/.test(_ua);
        var _isFirefox=/Firefox/.test(_ua);
        var _isChrome=/Chrome/.test(_ua)&&!_isEdge&&!_isOpera&&!_isYandex;
        var _isSafari=/Safari/.test(_ua)&&!/Chrome|Chromium|Edg|Firefox/.test(_ua);
        var _altBrowser=_isFirefox?'Chrome':(_isChrome||_isEdge||_isOpera||_isYandex||_isSafari)?'Firefox':'Firefox';
        /* FFmpeg WASM processes both audio AND video, so "media engine" is */
        /* accurate; the previous "audio engine" wording was confusing on the */
        /* 14+ video-only tools (video-flip, video-trim, video-crop, …). */
        /* Fail advice: refresh + alt-browser, NOT "update your browser" — the */
        /* latter is wrong for users already on the latest version (e.g. the */
        /* 2026-05-03 Edge 147 / RU report on /video-flip). */
        /* simdFail: shown when WASM-SIMD pre-flight fails (1.3 % of sessions — */
        /* pre-2008 CPUs without SSE 4.1). Distinct from generic fail because */
        /* (a) retry won't help — hardware doesn't change, (b) "try another */
        /* browser" advice is wrong — every modern engine uses SIMD too, */
        /* (c) the actionable fix is a different *device*, not a different */
        /* browser. See ffmpeg-processor.js __hasWasmSIMD pre-flight. */
        var M={
            en:{load:'Loading media engine…',src:'Source: :src (:n/:t)',retry:'Retrying :src (attempt :a)…',ready:'Media engine ready',fail:'Failed to load media engine. Refresh the page or try :alt.',simdFail:'This device\'s CPU is too old for modern WebAssembly. Please use a newer computer or phone.',failNet:'Could not download the media engine — the connection seems to have dropped. Press “Try again”.',copy:'Copy error'},
            ru:{load:'Загрузка медиа-движка…',src:'Источник: :src (:n/:t)',retry:'Повтор :src (попытка :a)…',ready:'Медиа-движок загружен',fail:'Не удалось загрузить медиа-движок. Обновите страницу или попробуйте :alt.',simdFail:'Процессор этого устройства слишком старый для современного WebAssembly. Откройте сайт на более новом компьютере или телефоне.',failNet:'Не удалось скачать медиа-движок — похоже, соединение прервалось. Нажмите «Попробовать снова».',copy:'Копировать ошибку'},
            ko:{load:'미디어 엔진 로딩 중…',src:'소스: :src (:n/:t)',retry:':src 재시도 (시도 :a)…',ready:'미디어 엔진 준비 완료',fail:'미디어 엔진 로드 실패. 페이지를 새로고침하거나 :alt를 사용해 보세요.',simdFail:'이 기기의 CPU는 최신 WebAssembly에 너무 오래되었습니다. 더 새로운 컴퓨터나 휴대폰을 사용해 주세요.',failNet:'미디어 엔진을 내려받지 못했습니다. 연결이 끊긴 것 같습니다. “다시 시도”를 눌러 주세요.',copy:'오류 복사'},
            ar:{load:'جارٍ تحميل محرك الوسائط…',src:'المصدر: :src (:n/:t)',retry:'إعادة المحاولة :src (المحاولة :a)…',ready:'محرك الوسائط جاهز',fail:'فشل تحميل محرك الوسائط. حدّث الصفحة أو جرّب :alt.',simdFail:'وحدة المعالجة المركزية لهذا الجهاز قديمة جدًا لتشغيل WebAssembly الحديث. جرّب جهازًا أحدث.',failNet:'تعذّر تنزيل محرك الوسائط — يبدو أن الاتصال انقطع. اضغط «حاول مرة أخرى».',copy:'نسخ الخطأ'},
            id:{load:'Memuat mesin media…',src:'Sumber: :src (:n/:t)',retry:'Mencoba ulang :src (percobaan :a)…',ready:'Mesin media siap',fail:'Gagal memuat mesin media. Muat ulang halaman atau coba :alt.',simdFail:'CPU perangkat ini terlalu lawas untuk WebAssembly modern. Silakan gunakan komputer atau ponsel yang lebih baru.',failNet:'Gagal mengunduh mesin media — sepertinya koneksi terputus. Tekan “Coba lagi”.',copy:'Salin error'},
            pt:{load:'Carregando mecanismo de mídia…',src:'Fonte: :src (:n/:t)',retry:'Tentando novamente :src (tentativa :a)…',ready:'Mecanismo de mídia pronto',fail:'Falha ao carregar o mecanismo de mídia. Atualize a página ou tente :alt.',simdFail:'A CPU deste dispositivo é antiga demais para o WebAssembly moderno. Use um computador ou telefone mais recente.',failNet:'Não foi possível descarregar o mecanismo de mídia — parece que a ligação caiu. Carregue em “Tentar novamente”.',copy:'Copiar erro'},
            de:{load:'Medien-Engine wird geladen…',src:'Quelle: :src (:n/:t)',retry:'Wiederholung :src (Versuch :a)…',ready:'Medien-Engine bereit',fail:'Medien-Engine konnte nicht geladen werden. Seite aktualisieren oder :alt verwenden.',simdFail:'Die CPU dieses Geräts ist zu alt für modernes WebAssembly. Bitte einen neueren Computer oder ein neueres Telefon verwenden.',failNet:'Die Medien-Engine konnte nicht heruntergeladen werden — die Verbindung scheint abgebrochen zu sein. Bitte „Erneut versuchen“ drücken.',copy:'Fehler kopieren'},
            es:{load:'Cargando el motor multimedia…',src:'Fuente: :src (:n/:t)',retry:'Reintentando :src (intento :a)…',ready:'Motor multimedia listo',fail:'No se pudo cargar el motor multimedia. Actualiza la página o prueba :alt.',failNet:'No se pudo descargar el motor multimedia: parece que se cortó la conexión. Presiona “Reintentar”.',simdFail:'La CPU de este dispositivo es demasiado antigua para el WebAssembly moderno. Usa una computadora o un teléfono más nuevo.',copy:'Copiar error'},
            fr:{load:'Chargement du moteur multimédia…',src:'Source : :src (:n/:t)',retry:'Nouvelle tentative :src (essai :a)…',ready:'Moteur multimédia prêt',fail:'Impossible de charger le moteur multimédia. Actualisez la page ou essayez :alt.',failNet:'Impossible de télécharger le moteur multimédia : la connexion semble avoir été interrompue. Appuyez sur « Réessayer ».',simdFail:'Le processeur de cet appareil est trop ancien pour le WebAssembly moderne. Utilisez un ordinateur ou un téléphone plus récent.',copy:'Copier le message'},
            uk:{load:'Завантаження медіарушія…',src:'Джерело: :src (:n/:t)',retry:'Повтор :src (спроба :a)…',ready:'Медіарушій завантажено',fail:'Не вдалося завантажити медіарушій. Оновіть сторінку або спробуйте :alt.',simdFail:'Процесор цього пристрою застарий для сучасного WebAssembly. Скористайтеся новішим комп’ютером або телефоном.',failNet:'Не вдалося завантажити медіарушій — здається, зникло з’єднання. Натисніть «Спробувати ще раз».',copy:'Скопіювати помилку'},
        };
        var m=M[L]||M.en;
         /* ── Отложенный повтор загрузки движка ────────────────────────────
           Каскад источников (local ×2 → jsdelivr-proxy ×2 → unpkg-proxy ×2 →
           прямые CDN) укладывается в ~8 секунд — ЗАМЕРЕНО пробником: 21
           оборванный запрос за 8 c. Значит перебои ДЛИННЕЕ восьми секунд
           убивают сессию целиком: все попытки попадают внутрь одного провала,
           а нового захода никто не делает. Так за 30 дней 1745 сессий на 91
           туле не получили НИЧЕГО, и ни одна не восстановилась.
           Повтор ЧЕРЕЗ паузу — это не то же самое, что ещё одна попытка внутри
           каскада: он щупает ДРУГОЙ момент времени. Два повтора (15 c и 45 c)
           расширяют покрытое окно с 8 секунд примерно до минуты.
           Границы намеренные: только сетевой класс отказа (у железа и у
           заблокированного WebAssembly повтор не изменит ничего), не больше
           двух раз, и любой успех их отменяет. */
        var _autoRetryN=0,_autoRetryTimer=null,_retriedThisPage=false,_lastRawErr='';
         /* ⚠️ Отказ приезжает ДВАЖДЫ: сперва «INIT_FAILED | local#1: Failed to
           fetch | …» с настоящим диагнозом по каждому источнику, следом
           «INIT_ERROR | <локализованный текст>», который его затирает. Внешний
           catch в ffmpeg-processor ловит уже переведённую ошибку, поэтому по
           второму событию отличить сетевой отказ от заблокированного
           WebAssembly НЕЛЬЗЯ. Запоминаем первый. */
        function _cancelAutoRetry(){ if(_autoRetryTimer){clearTimeout(_autoRetryTimer);_autoRetryTimer=null;} }
        function _clearBannerExtras(){
            var rb=el.querySelector('.ffld-retry');if(rb)rb.remove();
            var od=el.querySelector('.ffld-detail');if(od)od.remove();
            var oc=el.querySelector('.ffld-copy');if(oc)oc.remove();
        }
        function _runEngineRetry(how,n){
            try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'engine_retry',how:how,n:n,tool:(window.__TOOL_SLUG||'')})}catch(_){}
            _retriedThisPage=true;
            el.classList.remove('ffld-error');
            txt.textContent=m.load||'Loading...';
            _clearBannerExtras();
            if(!window.FFmpegProcessor)return;
            FFmpegProcessor._lastError=null;
            /* A retry starts from a clean gate — the same reset the «Попробовать
               снова» button does. The cascade watcher (wasm-health.js) cuts a
               failing ladder short by setting __wasmInitAborted, and init()
               refuses to run while it is set; until 2026-09-17 the watcher was
               dead (see its note), so this retry never met the flag. Alive, it
               would have turned every automatic retry into an instant
               ENGINE_PRE_ABORTED refusal — measured by engine-load-retry.mjs:
               «повтор виден, успешного исхода нет». */
            if(typeof window.__wasmHealthReset==='function')window.__wasmHealthReset(true);
            else try{sessionStorage.setItem('__wasm_health','1')}catch(_){}
            window.__wasmInitAborted=false;
             /* ⚠️ Если повтор тоже не удался, отказ надо ПОКАЗАТЬ заново: иначе
               кнопка уже снята, баннер навсегда застыл на «Загрузка…», и
               следующий отложенный повтор не назначается. Замерено сторожем:
               без этого после первого авто-повтора кнопки нет и второй попытки
               тоже нет — то есть было бы ХУЖЕ, чем до правки. */
            function _retryFailed(){
                try{window.dispatchEvent(new CustomEvent('ffmpeg-status',{detail:{phase:'failed',error:(window.FFmpegProcessor&&FFmpegProcessor._lastError)||_lastRawErr||'retry failed'}}))}catch(_){}
            }
            var _pr;try{_pr=FFmpegProcessor.reinit()}catch(_){_retryFailed();return}
            if(_pr&&_pr.then)_pr.then(function(okv){if(okv!==true)_retryFailed()},function(){_retryFailed()});
        }
        function _scheduleAutoRetry(){
            if(_autoRetryN>=2||_autoRetryTimer)return;
            var delay=_autoRetryN===0?15000:45000;
            _autoRetryN++;
            var n=_autoRetryN;
            _autoRetryTimer=setTimeout(function(){
                _autoRetryTimer=null;
                if(!window.FFmpegProcessor)return;
                try{ if(FFmpegProcessor.isReady&&FFmpegProcessor.isReady())return; }catch(_){}
                _runEngineRetry('auto',n);
            },delay);
        }
        window.__ffEngineRetryState=function(){return{auto:_autoRetryN,pending:!!_autoRetryTimer,retried:_retriedThisPage}};
        window.addEventListener('ffmpeg-status',function(ev){
            var d=ev.detail;
            el.classList.remove('ffld-error');
            var old=el.querySelector('.ffld-detail');if(old)old.remove();
            var oldC=el.querySelector('.ffld-copy');if(oldC)oldC.remove();
             /* И кнопку тоже: каждое новое событие 'failed' дописывало ЕЩЁ одну,
               и на проде в баннере стояло «Попробовать снова Попробовать снова». */
            var oldR=el.querySelector('.ffld-retry');if(oldR)oldR.remove();
            if(d.phase==='downloading'){
                el.classList.add('visible');
                var s=m.src.replace(':src',d.source||'CDN').replace(':n',d.sourceIndex||1).replace(':t',d.totalSources||3);
                txt.textContent=m.load+' '+s;
            }else if(d.phase==='retrying'){
                el.classList.add('visible');
                txt.textContent=m.retry.replace(':src',d.source||'').replace(':a',d.attempt||2);
            }else if(d.phase==='ready'){
                _cancelAutoRetry();_lastRawErr='';
                if(_retriedThisPage){try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'engine_retry_recovered',n:_autoRetryN,tool:(window.__TOOL_SLUG||'')})}catch(_){}_retriedThisPage=false;}
                txt.textContent=m.ready;
                setTimeout(function(){el.classList.remove('visible')},2000);
            }else if(d.phase==='failed'){
                el.classList.add('visible','ffld-error');
                var _isSimdFail=d.reason==='simd_unsupported';
                 /* ── Отказ СКАЧИВАНИЯ ≠ отказ окружения ────────────────────
                   ЗАМЕРЕНО 30 дней: `ffmpeg-src-fail` — 2018 сессий на 91 туле,
                   и из 1745 (без «terminate()», т.е. без ушедших со страницы)
                   НИ ОДНА не получила результата. При этом телеметрия от всех
                   доехала — значит сеть у них работала, отвалилась именно
                   32-мегабайтная загрузка ядра.
                   Разбор причин: «Failed to fetch» 926 сессий + «Load failed»
                   502 — сетевой класс; «Instantiate timeout» 193 (наш дедлайн
                   60 c, не жадный).
                   ПРОВЕРЕНО пробником на живом проде: движок НЕ залипает —
                   после отказа всего каскада обычный `init()` проходит за 4 c,
                   как только причина ушла, и кнопка «Попробовать снова»
                   восстанавливает всё вместе с уже загруженными файлами.
                   Значит совет «Обновите страницу или попробуйте Firefox» вёл
                   мимо: перезагрузка стоит человеку загруженных файлов, смена
                   браузера к скачиванию отношения не имеет, а работающая
                   кнопка стоит рядом. */
                if(/INIT_FAILED\s*\|/.test(String(d.error||'')))_lastRawErr=String(d.error||'');
                var _netClass = !_isSimdFail && /failed to fetch|load failed|networkerror|http \d|stall|timeout|aborted/i.test(_lastRawErr||String(d.error||''));
                txt.textContent=_isSimdFail?m.simdFail:(_netClass&&m.failNet?m.failNet:m.fail.replace(':alt',_altBrowser));
                 /* Сетевой класс — щупаем ещё раз через паузу. Железо и
                   заблокированный WebAssembly сюда не попадают: там повтор
                   ничего не изменит, и обещать его нечестно. */
                if(_netClass)_scheduleAutoRetry();
                /* Close the diagnostic hole: bug-reports filed during a WASM */
                /* init failure used to land with `last_error: null` because */
                /* ffmpeg-processor.js only emitted analytics_events */
                /* (wasm_init_failed) and never set the global error global */
                /* that feedback-widget snapshots from. Setting it here means */
                /* every tool that depends on FFmpeg WASM (60+) gets correct */
                /* last_error attribution at submit time, without per-tool */
                /* wiring. Real-case: 2026-05-03 sid 58e4dcf9 on /video-flip */
                /* submitted with last_error:null even though the user was */
                /* staring at the failed-engine banner. */
                try {
                    var __slug=(document.querySelector('meta[name=tool-slug]')||{}).content||null;
                    var __c=navigator.connection||navigator.mozConnection||{};
                    window.__LAST_TOOL_ERROR={
                        tool:__slug,
                        stage:'wasm_init',
                        reason:d.reason||'engine_load_failed',
                        msg:String(d.error||'unknown').slice(0,200),
                        dm:navigator.deviceMemory||0,
                        ct:__c.effectiveType||'',
                        dl:__c.downlink||0,
                        ts:Date.now()
                    };
                } catch(_){}
                /* SIMD-unsupported is hardware-final: skip the retry button */
                /* and the raw "Compiling function #81 failed: Wasm SIMD */
                /* unsupported @+70121" string (cryptic to users). The */
                /* simdFail message above already explains it cleanly. */
                if(_isSimdFail) return;
                /* Retry button — lets user try loading again */
                var retryBtn=document.createElement('button');
                retryBtn.className='ffld-retry';
                retryBtn.textContent=({"en":"Try again","ru":"Попробовать снова","ko":"다시 시도","ar":"حاول مرة أخرى","id":"Coba lagi","pt":"Tentar novamente","de":"Erneut versuchen","es":"Reintentar","fr":"Réessayer","uk":"Спробувати ще раз"})[window.__LOCALE]||'Try again';
                retryBtn.style.cssText='margin-left:8px;padding:4px 12px;background:var(--accent,#38bdf8);color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:12px;font-weight:600';
                retryBtn.onclick=function(){
                     /* Нажатий этой кнопки НИКТО не считал — поэтому и нельзя
                       было узнать, доходит ли до неё человек. Теперь считаем
                       и нажатие, и исход (engine_retry_recovered). */
                    _cancelAutoRetry();
                    _runEngineRetry('manual',0);
                };
                el.appendChild(retryBtn);
                if(d.error){
                    var det=document.createElement('span');det.className='ffld-detail';det.textContent=d.error;el.appendChild(det);
                    var cp=document.createElement('span');cp.className='ffld-copy';cp.textContent=m.copy;
                    cp.onclick=function(){var t='FFmpeg: '+d.error+' | '+navigator.userAgent+' | '+location.href;if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(function(){cp.textContent='\u2713'}).catch(function(){});}else{try{var ta=document.createElement('textarea');ta.value=t;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);cp.textContent='\u2713';}catch(e){}}};
                    el.appendChild(cp);
                }
            }else{
                el.classList.remove('visible');
            }
        });
    })();

/* ── sw-register ─────────────────────────────────────────────── */
if('serviceWorker' in navigator && navigator.serviceWorker){
 /* UA gate — old engines can't parse ES2020 optional chaining in sw.js
   (line 742). 2026-06-22..24 telemetry: 28% of all sw_register_failed
   bucketed as "ServiceWorker script evaluation failed", UA mix dominated
   by Chrome 79/78/74/72/68 mobile and iOS 12 Safari. Skip registration on
   KNOWN-broken engines instead of throwing — silence the false alerts AND
   the broken users get a working site (no SW = no offline + no precache,
   but the page works). Modern engines untouched. */
var _swUa=navigator.userAgent;
var _swCm=_swUa.match(/Chrom(?:e|ium)\/(\d+)/);
var _swSm=_swUa.match(/Version\/(\d+)\.(\d+).*Safari/);
var _swIm=_swUa.match(/(?:iPhone|iPad).+OS (\d+)_(\d+)/);
var _swSkip=false;
if(_swCm&&parseInt(_swCm[1],10)<80)_swSkip=true;
if(_swSm&&(parseInt(_swSm[1],10)<13||(parseInt(_swSm[1],10)===13&&parseInt(_swSm[2],10)<4)))_swSkip=true;
if(_swIm&&(parseInt(_swIm[1],10)<13||(parseInt(_swIm[1],10)===13&&parseInt(_swIm[2],10)<4)))_swSkip=true;
if(_swSkip){try{window.__aeCritical&&window.__aeCritical('sw_register_skipped_old_engine',{ua:_swUa.substring(0,150)});}catch(_){}}
else{window.addEventListener('load',function(){navigator.serviceWorker.register('/sw.js',{updateViaCache:'none'}).then(function(reg){reg.addEventListener('updatefound',function(){var w=reg.installing;if(w){w.addEventListener('statechange',function(){if(w.state==='installed'&&navigator.serviceWorker.controller){w.postMessage({type:'SKIP_WAITING'})}})}})}).catch(function(e){console.warn('[SW] Registration failed:',e);
 /* 2026-06-23: full error message capture. Earlier .slice(0,80) cut OFF
   right before the actual cause — Chromium error format is
   "Failed to register a ServiceWorker for scope ('https://timbrica.com/') with script ('https://timbrica.com/sw.js'): <ACTUAL REASON>"
   so 80 chars consumed scope+script and the diagnostic <REASON>
   ("404 was received", "unsupported MIME type", "script evaluation failed",
   "An unknown error occurred when fetching the script") never reached
   telemetry. 1800+ events over 8 days were therefore unbucketed.
   We need at least 350 chars to ALWAYS land the colon-suffix. Also
   probe context (had previous registration? online? storage quota?
   navigator.cookieEnabled? caches API present?) to classify each cause. */
try{
  var pre={err_name:(e&&e.name)||'unknown',err_msg:((e&&e.message)||'').slice(0,400),online:!!navigator.onLine,cookies:!!navigator.cookieEnabled,caches_api:!!window.caches,had_prior:0};
  /* had_prior — was there an old SW registration BEFORE this attempt? */
  /* Classifies "stale state conflict" vs "fresh-install failure". Async, */
  /* so wrap together with the beacon to keep the order. */
  (async function(){
    try{
      if(navigator.serviceWorker&&navigator.serviceWorker.getRegistration){
        var prior=await navigator.serviceWorker.getRegistration();
        pre.had_prior=prior?1:0;
        if(prior){pre.prior_scope=String(prior.scope||'').slice(0,80);pre.prior_active=!!prior.active;}
      }
    }catch(_){}
    try{
      if(navigator.storage&&navigator.storage.estimate){
        var est=await navigator.storage.estimate();
        if(est){pre.quota_mb=Math.round((est.quota||0)/1048576);pre.usage_mb=Math.round((est.usage||0)/1048576);}
      }
    }catch(_){}
     /* 2026-06-24: Yandex in-app WebView demote to environmental class.
       31% of sw_register_failed bucket #1 is Yandex's in-app shell — the
       shell strips ServiceWorker support and the register call throws
       "ServiceWorker cannot be started". Not a Timbrica bug, not actionable,
       just the user opening our page from inside Yandex Search / Поиск /
       Браузер's webview opt-out container. Emit as sw_register_environmental
       so it doesn't compete with real regressions for alert attention.
       UA tokens: YaApp_Android (search app shell), ya.com (rarer). Also
       trigger on "cannot be started" in err.message even on non-Yandex UA —
       some Android OEM webviews emit the same error class. */
    var _swEnv=false;
    try{
      var _swUa2=navigator.userAgent||'';
      var _swMsg=String(pre.err_msg||'');
      var _swYa=/YaApp_Android|ya\.com/i.test(_swUa2);
      var _swCantStart=/cannot be started/i.test(_swMsg);
       /* Demote only when we have a Yandex UA signal — that's the 31% bucket
         we're trying to silence. The "cannot be started" check by itself
         would also catch non-Yandex Android OEM webviews, but those aren't
         in the noisy bucket today; keep them as sw_register_failed so we
         see them rise if a new OEM ships a broken webview. */
      if(_swYa||(_swYa&&_swCantStart))_swEnv=true;
    }catch(_){}
    try{window.__aeCritical&&window.__aeCritical(_swEnv?'sw_register_environmental':'sw_register_failed',pre);}catch(_){}
  })();
}catch(_){}})});}
window.__resetSW=async function(){if(!navigator.serviceWorker)return;try{var regs=await navigator.serviceWorker.getRegistrations();for(var i=0;i<regs.length;i++){try{if(regs[i].active)regs[i].active.postMessage({type:'RESET_SW'})}catch(e){}try{await regs[i].unregister()}catch(e){}}if(window.caches){var keys=await caches.keys();await Promise.all(keys.map(function(k){return caches.delete(k)}))}}catch(e){console.warn('[SW reset]',e)}location.reload();}}

window.__layoutSharedLoaded = true;
